import { PERSON_GROUP  } from "actions/types";
import { baseStore } from "../common/baseStore"

export default baseStore(PERSON_GROUP)
